// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kpi-table {
  width: 100%;
  table-layout: fixed;
}

.kpi-table thead {
  background-color: #f0f0f0;
  position: sticky;
  top: 0;
  z-index: 3;
}`, "",{"version":3,"sources":["webpack://./src/pages/analytics/KPITable.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,mBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AACJ","sourcesContent":[".kpi-table {\r\n    width: 100%;\r\n    table-layout: fixed;\r\n}\r\n\r\n.kpi-table thead {\r\n    background-color: #f0f0f0;\r\n    position: sticky;\r\n    top: 0;\r\n    z-index: 3;\r\n}\r\n  \r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
